import { getTopPartnerId } from 'legacy/lut/helpers/getTopPartnerId'
import { useEffect, useState } from 'react'

export function useTopPartnerId(partnerId: string) {
  const [topPartnerId, setTopPartnerId] = useState(partnerId)

  useEffect(() => {
    getTopPartnerId(partnerId).then(setTopPartnerId)
  }, [partnerId])

  return { topPartnerId }
}
